import { Component, EventEmitter, Input, Output } from '@angular/core';
import { sortBy } from 'lodash';
import { CartItem } from '../data/models';

export interface CartItemAction {
  item: CartItem;
  action: 'edit' | 'increaseQuantity' | 'decreaseQuantity';
}

@Component({
    selector: 'app-cart-item[item]',
    template: `
    <div class="d-flex justify-content-between align-items-center py-1">
      <div class="d-flex justify-content-start flex-nowrap align-items-center flex-shrink-1 flex-grow-1 w-50 me-2">
        <button type="button" class="btn btn-rounded-icon btn-light-info me-2 flex-shrink-0"
                *ngIf="!readonly"
                (click)="editItem()">
          <span class="material-icons md-24">edit</span>
        </button>
        <div
          class="product-image-placeholder border-medium border bg-white w-48px h-48px me-2 position-relative flex-shrink-0"
          [style.background-image]="image && 'url(' + image + ')'">
          <div class="position-absolute start-100 translate-middle badge rounded-pill bg-info">
            {{item.quantity}}
          </div>
        </div>
        <div class="text-wrap mw-100 overflow-hidden ms-2 d-flex flex-column">
          <div class="item-text" [ngClass]="orderedItemOptions.length > 0 ? 'single-line' : 'multi-line'">{{item.title}}</div>
          <div>
            <span *ngFor="let option of orderedItemOptions">{{option.name}} {{option.selectedValue}}&nbsp;</span>
          </div>
        </div>
      </div>
      <div class="fs-6 d-flex align-items-end justify-content-center flex-column flex-shrink-0 w-25 flex-grow-0 me-2">
        <span class="text-info fs-5 text-nowrap">{{item.linePrice | currency}}</span>
        <span class="text-danger text-nowrap" *ngIf="item.discountAmount && item.discountType === 'absolute'"><span
          i18n>Rabatt: </span>{{item.discountAmount | currency}}</span>
        <span class="text-danger text-nowrap" *ngIf="item.discountAmount && item.discountType === 'relative'"><span
          i18n>Rabatt: </span>{{item.discountAmount}}%</span>
        <span class="text-nowrap" *ngIf="item.quantity > 1" i18n>{{item.price | currency}}/Stk</span>
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .badge {
      top: 6px;
    }
    .item-text {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      &.single-line {
        -webkit-line-clamp: 1;
      }
      &.multi-line {
        -webkit-line-clamp: 2;
      }
    }
    .fs-16px {
      font-size: 16px;
    }
  `],
    standalone: false
})
export class CartItemComponent {
  @Input() showItemCounters = false;
  @Input() readonly = false;
  @Input() item!: CartItem;
  @Output() itemChange: EventEmitter<CartItemAction> = new EventEmitter<CartItemAction>();

  get orderedItemOptions() {
    return sortBy(this.item.options, option => option.position);
  }

  get image(): string {
    return this.item.image?.url || '';
  }

  editItem() {
    this.itemChange.emit({
      item: this.item,
      action: 'edit'
    });
  }
}
